import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Component, DestroyRef, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SettlementsService } from 'src/app/services/settlements.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BreadcrumbService } from 'xng-breadcrumb';
import { environment } from 'src/environments/environment';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { ModalUnitComponent } from 'src/app/components/modals/modal-unit.component';
import { ModalTenantComponent } from 'src/app/components/modals/modal-tenant.component';
import { Unit } from 'src/app/models/unit.model';
import { Tanque } from 'src/app/models/tanque.model';
import { Building } from 'src/app/models/building.model';
import { Settlement } from 'src/app/models/settlement.model';
import { Tenant } from 'src/app/models/tenant.model';
import { Utility } from 'src/app/models/utility.model';
import { ModalSearchTenantComponent } from 'src/app/components/modals/modal-search-tenant.component';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { GasMeter } from 'src/app/models/gas-meter.model';
import { map, Subscription, switchMap, timer } from 'rxjs';
import { OperationsStartDateStatus } from './operations-start-date-status/operations-start-date-status';
import { formatDiscountValue } from 'src/app/shared/utils/discount-type.utils';
import { UnitOperationsState } from 'src/app/models/unit-operations-state.model';
import { normalizeOptionalBoolean } from 'src/app/shared/utils/contract-term.utils';


@Component({
  selector: 'app-tenant',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Condominios y comercial</h1>
      </div>
    </div>
    <div class="d-flex mb-4">
      <div class="me-3 d-none d-md-block">
        <ul app-nav-settlements class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill mx-2 mx-sm-0">
        <div class="d-flex">
          <div class="flex-fill">
            <h5 class="mb-0">Condominio</h5>
            <h2>{{settlement?.name}}</h2>
            <h4>{{building?.name}}</h4>
            <div *ngIf="!loading">
              <xng-breadcrumb separator="/" class="float-start"></xng-breadcrumb>
              <li class="nav-item dropdown list-unstyled" ngbDropdown>
                <a class="nav-link dropdown-toggle dropdown-toggle-alt" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                  <fa-icon [icon]="icons.faChevronDown" class="float-start ms-1" style="font-size: 12px; position: absolute; top: 0;"></fa-icon>
                </a>
                <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarScrollingDropdown">
                  <li ngbDropdownItem *ngFor="let unit of units" routerLink="/condominios/{{settlement?.id}}/unidad/{{unit.id}}">{{unit.name}}</li>
                </ul>
              </li>
            </div>
            <div *ngIf="loading">
              <p class="mb-0" style="font-size: 16px !important;">Cargando...</p>
            </div>
          </div>
          <div class="ms-auto mt-4">
            <button type="button" (click)="generateBill()" [disabled]="pending_bills" class="btn btn-outline-secondary rounded-3" >
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Pago adelantado
            </button>
            <button class="btn btn-secondary rounded-3 ms-3" routerLink="/pagos/recibos/new/{{unit?.id}}">Crear recibo</button>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="flex-fill">
            <div class="list-group">
              <div class="list-group-item py-3">
                <div class="d-flex">
                  <div class="flex-fill">
                    <h3>{{unit?.name}}</h3>
                    <p class="mb-0">{{unit?.number}}</p>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="flex-fill">
                    <div class="badge badge-pill border border-2 border-success bg-transparent text-success rounded-5 float-end px-3" *ngIf="unit?.status===1">Activo</div>
                    <div class="badge badge-pill border border-2 border-warning bg-transparent text-warning rounded-5 float-end px-3" *ngIf="unit?.status===0">Inactivo</div>
                    <div class="d-flex unit-actions-status">
                      <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="editUnit()">
                      Editar
                    </button>
                    @if(this.unitId !== 0) {
                      <app-operations-start-date-status [state]="operationsState()"></app-operations-start-date-status>
                    }
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-group-item py-3">
                <h5>Configuración</h5>
                <div class="d-flex">                
                  <table class="table table-sm" style="font-size: 0.9em;">
                    <tbody>
                      <tr>
                        <td>Factor</td>
                        <td class="text-end">
                          <span *ngIf="unit?.factor">{{unit?.factor}}</span>
                          <span *ngIf="!unit?.factor&&settlement?.factor">{{settlement?.factor}}</span>
                          <span *ngIf="!unit?.factor&&!settlement?.factor">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Costo administrativo</td>
                        <td class="text-end">
                          <span *ngIf="unit?.admin_price">{{unit?.admin_price | currency}}</span>
                          <span *ngIf="!unit?.admin_price&&settlement?.admin_price">{{settlement?.admin_price | currency}}</span>
                          <span *ngIf="!unit?.admin_price&&!settlement?.admin_price">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Cargos moratorios %</td>
                        <td class="text-end">
                          <span *ngIf="unit?.interests">{{unit?.interests}}</span>
                          <span *ngIf="!unit?.interests&&settlement?.interests">{{settlement?.interests}}</span>
                          <span *ngIf="!unit?.interests&&!settlement?.interests">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Costo de reconexión</td>
                        <td class="text-end">
                          <span *ngIf="unit?.reconexion_fee">{{unit?.reconexion_fee | currency}}</span>
                          <span *ngIf="!unit?.reconexion_fee&&settlement?.reconexion_fee">{{settlement?.reconexion_fee | currency}}</span>
                          <span *ngIf="!unit?.reconexion_fee&&!settlement?.reconexion_fee">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Descuento por litro</td>
                        <td class="text-end">
                          {{ formatApplicableDiscount() }}
                        </td>
                      </tr>
                      <tr>
                        <td>Periodicidad</td>
                        <td class="text-end">
                          <span *ngIf="unit?.periodicity">{{unit?.periodicity}}</span>
                          <span *ngIf="!unit?.periodicity&&settlement?.periodicity">{{settlement?.periodicity}}</span>
                          <span *ngIf="!unit?.periodicity&&!settlement?.periodicity">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Días crédito</td>
                        <td class="text-end">
                          <span *ngIf="unit?.credit">{{unit?.credit}}</span>
                          <span *ngIf="!unit?.credit&&settlement?.credit">{{settlement?.credit}}</span>
                          <span *ngIf="!unit?.credit&&!settlement?.credit">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="list-group-item py-3" [ngClass]="subscriptions.length == 0 ? 'list-group-item-danger' : ''">
                <div *ngIf="subscriptions.length==0">
                  <h5>Agrega subscripciones para esta unidad</h5>
                  <div class="list-group">
                    <div class="list-group-item clearfix" *ngFor="let utility of utilities">
                      <p class="text-start float-start pt-1 mb-0">{{utility.name}}</p>
                      <button class="btn btn-sm btn-outline-primary text-end float-end pb-0" (click)="addSubscription(utility.id)" [disabled]="savingSubscription">
                        <fa-icon [icon]="icons.faPlus"></fa-icon>
                      </button>
                    </div>
                  </div>
                </div>
                
                <div *ngIf="subscriptions.length>0">
                  <h5>Subscripciones</h5>
                  <div class="list-group mt-3">
                    <li class="list-group-item" *ngFor="let subscription of subscriptions">
                      <span>{{subscription.utility.name}}</span>
                    </li>
                  </div>
                </div>
              </div>

              <div class="list-group-item py-3" >
                <h5>Tanque asignado</h5>
                <div *ngIf="!unit?.tanque_id">
                  <div class="list-group-item" *ngFor="let tanque of building?.tanques">
                    <div class="d-flex">
                      <div><ngx-emoji emoji="alembic" [style]="{ bottom: '10px', right: '2px' }"></ngx-emoji></div>
                      <div><h5 class="mb-0 mt-2 ms-2">{{tanque.name}}</h5></div>
                      <div><p class="mb-0 ms-2 mt-1" style="font-size: 0.8em; line-height: 1;">Capacidad: {{tanque.capacidad}} {{tanque.unidad}}</p></div>
                      <div class="ms-auto">
                        <button type="button" class="btn btn-sm btn-outline-info ms-2" (click)="addTanque(tanque.id)">
                          <fa-icon [icon]="icons.faPlus" size="1x"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="unit?.tanque_id">
                  <div class="list-group-item" *ngIf="tanque">
                    <div class="row">
                      <div class="col-md-1">
                        <ngx-emoji emoji="alembic" [style]="{ bottom: '10px', right: '2px' }"></ngx-emoji>
                      </div>
                      <div class="col-md-9">
                        <h5 class="mb-0 mt-1">{{tanque.name}}</h5>
                      </div>
                      <div class="col-md-2 text-end">
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeTanque(tanque)">
                          <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="list-group-item py-3">
                <div class="d-flex">
                  <div>
                    <h5 class="mt-2">INQUILINOS</h5>
                  </div>
                  <div class="ms-auto">
                    <button class="btn btn-outline-secondary btn-sm" (click)="addTenant()">
                      <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                      Agregar inquilino
                    </button>
                    <button class="btn btn-outline-secondary btn-sm ms-2" (click)="searchTenant()">
                      <fa-icon [icon]="icons.faSearch"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="list-group mt-3">
                  <div class="list-group-item p-0" *ngFor="let tenant of unit?.tenants">
                    <app-item-sm-tenant [tenant]="tenant"></app-item-sm-tenant>
                  </div>
                </div>
              </div>

              <div #contracts class="list-group-item py-3">
                <section app-contract-unit 
                  [settlement]="settlement"
                  [profile]="profile"
                  [permissions]="permissions"
                  [tenants]="tenants"
                  [unit]="unit"
                  [tanque]="tanque"
                ></section>
              </div>

            </div>
          </div>
          <div class=" ms-3" style="width: 500px; max-width: 500px;">
            <div class="list-group">
              <div #gas_meters class="list-group-item py-3">
                <section 
                  app-meter-unit 
                  [medidores]="medidores"
                  [unit]="unit"
                  [permissions]="permissions"
                  (updateData)="reloadData(500)"
                ></section>
              </div>
              <div #payments class="list-group-item py-3" *ngIf="unit">
                <section 
                  app-unit-payments
                  [unit]="unit"
                  [profile]="profile"
                  [permissions]="permissions"
                  [summary]="summary"
                ></section>
              </div>
              <div #historic class="list-group-item py-3" *ngIf="unit">
                <section
                  app-historic-consumptions
                  [unit]="unit"
                  [permissions]="permissions"
                ></section>
              </div>
            </div>
          </div> 
        <div>        
      </div>  
         
    </div>
      
    <app-modal-tenant [unit]="unit" [building]="building" [profile]="profile" [settlement]="settlement!" [permissions]="permissions" (updateDismiss)="reloadData()"></app-modal-tenant>
    <app-modal-unit [unit]="unit" [operationsState]="operationsState()" (updateDismiss)="reloadData()"></app-modal-unit>
    <app-modal-search-tenant 
      [unit]="unit"
      [profile]="profile" 
      [permissions]="permissions" 
      (updateDismiss)="refreshTenants()"
    ></app-modal-search-tenant> 

  `,
  styleUrls: [],
})
export class TenantComponent {
  readonly formatDiscountValue = formatDiscountValue;
  @ViewChild(ModalUnitComponent, { static: true }) modalUnitComponent !: ModalUnitComponent;
  @ViewChild(ModalTenantComponent, { static: true }) modalTenantComponent !: ModalTenantComponent;
  @ViewChild(ModalSearchTenantComponent, { static: true }) modalSearchTenantComponent !: ModalSearchTenantComponent;
  operationsState = signal<UnitOperationsState>({ unitId: 0, status: 'loading', startDate: null, errors: [] });
  private destroyRef = inject(DestroyRef);
  private unitRequest?: Subscription;
  private operationsRequest?: Subscription;
  
  apiUrl: string = environment.AWS_REST_WSPREFIX;
  receiptUrl: string = environment.RECIBOS_REST_WSPREFIX;

  activeMaintenance: boolean = false;

  profile: any = null;
  permissions: any = null;

  settlement: Settlement | null = null;
  building: Building | null = null;
  tanque: Tanque | null = null;
  unitId: number = 0;
  unit: Unit | null = null;
  summary: any = {};

  tenants: Tenant[] = [];
  subscriptions: any[] = [];
  utilities: Utility[] = [];
  medidores: GasMeter[] = [];
  units: Unit[] = [];

  loading: boolean = true;

  pending_bills: boolean = false;
  savingSubscription: boolean = false;
  unitForm: FormGroup = new FormGroup({});

  link: string = '';
  avatarURL: string = "";
  last_meter: string = "";
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private toastr: ToastrService,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    public images: ImageService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : {};
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : {};
    this.activateRoute.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.unitId = Number(params['id']);
      this.loadUnit(this.unitId);
    });
  }

  ngOnInit(): void {}

  formatApplicableDiscount(): string {
    const unitHasDiscount = this.unit?.discount !== null && this.unit?.discount !== undefined;
    return this.formatDiscountValue(
      unitHasDiscount ? this.unit?.discount : this.settlement?.discount,
      unitHasDiscount ? this.unit?.discount_type_id : this.settlement?.discount_type_id
    );
  }

  download() {
    window.open(`${this.link}.pdf`, '_blank');
  }

  reloadData(delay? : number) {
    this.loading = true;
    timer(delay || 0).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadUnit(this.unitId);
    });
  }

  protected loadUnit(unitId: any): void {
    this.unitRequest?.unsubscribe();
    this.operationsRequest?.unsubscribe();
    this.loading = true;
    this.operationsState.set({ unitId: Number(unitId), status: 'loading', startDate: null, errors: [] });
    this.unitRequest = this.store.getUnit(unitId).pipe(
      switchMap(unit => this.store.getUnitSettlement(unitId).pipe(map(context => ({ unit, context })))),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: ({ unit: data, context }: any) => {
        this.unit = data;
        this.tenants = data.tenants;
        this.link = data.contrato ? `${this.apiUrl}/storage/${data.contrato?.key.substring(0,2)}/${data.contrato?.key.substring(2,4)}/${data.contrato?.key}` : '';
        this.medidores = [...data.gas_meters];

        this.settlement = context.settlement;
        this.building = context.building;

        this.loadUtilities(this.unit);

        this.store.getUnitsByBuilding(context.building.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
          this.units = [...data];
        });

        this.breadcrumbService.set('@Index', `Comercial`);
        this.breadcrumbService.set('@unitName', `${this.unit?.name}`);
        this.breadcrumbService.set('@buildingName', `${this.settlement?.name}`);

        this.loading = false;
        if (Number(this.unit?.status) !== 1 || normalizeOptionalBoolean(this.settlement?.enabled) === false) {
          this.operationsState.set({ unitId: Number(unitId), status: 'inactive', startDate: null, errors: [] });
        } else {
          this.operationsRequest = this.store.getUnitOperationsState(Number(unitId))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(state => this.operationsState.set(state));
        }
      },
      error: (error: any) => {
        this.operationsState.set({ unitId: Number(unitId), status: 'unavailable', startDate: null, errors: [] });
        this.toastr.error('Unidad no pudo ser cargada. Intenta de nuevo más tarde', 'Error');
      }
    });
  }

  get ufc() {
    return this.unitForm.controls;
  }

  loadPDF(event: any): void {
    const reader = new FileReader();
    const ctl = this;
    var base64;
    var fileToLoad = event.target.files[0];
    reader.onload = function(fileLoadedEvent) {
      base64 = fileLoadedEvent.target!.result;
      // Print data in console
      console.log(base64);
      ctl.unitForm.patchValue({
        contrato: base64
      });
      let payload: any = {
        contrato: base64
      }
      ctl.savePDF(payload);
    };
    // Convert data to base64
    reader.readAsDataURL(fileToLoad);
  }

  savePDF(payload: any) {
    this.store.updateUnitContrato(this.unit!.id, payload).subscribe((data: any) => {
      this.loadUnit(this.unit!.id);
    });
  }

  removeContrato() {
    this.unitForm.patchValue({
      contrato: null,
    });
  }

  loadUtilities(unit: any) {
    this.store.getSubscription(this.unitId).subscribe((data: any) => {
      console.log('subscriptions data ==> ', data);
      this.subscriptions = data;
    });

    this.store.getUtilities({ page: 1, per_page: 100 }).subscribe((allUtilities: any) => {
      console.log('allUtilities => ', allUtilities);
      this.utilities = [];
      if (this.unit?.subscriptions && this.unit.subscriptions.length > 0) {
        this.unit.subscriptions.map((subscription: any) => {
          allUtilities.data.map((utility: any) => {

            if (subscription.utility_id != utility.id) {
              this.utilities.push(utility);
            }
            allUtilities.data.filter((utility: any) => utility.id != subscription.utility_id);
          });
        });
      } else {
        this.utilities = allUtilities.data;
      }
    });
  }

  generateBill() {
    this.route.navigate([`/pagos/recibos/unit/${this.unitId}`]);
  }

  addTanque(id: any) {
    this.store.updateUnit(this.unit?.id, { tanque_id: id }).subscribe({
      next: (data: any) =>  {
        this.toastr.success('Unidad se actualizó correctamente.', 'Éxito');
        this.loadUnit(this.unit?.id);
      },
      error: (error: any) => {
        console.error(error);
        this.toastr.error('Unidad no pudo ser actualizada.', 'Error');
      }
    });
  }

  removeTanque(tanque: any) {
    this.store.updateUnit(this.unit?.id, { tanque_id: null }).subscribe({
      next: (data: any) =>  {
        this.toastr.success('Unidad se actualizó correctamente.', 'Éxito');
        this.loadUnit(this.unit?.id);
      },
      error: (error: any) => {
        console.error(error);
        this.toastr.error('Unidad no pudo ser actualizada.', 'Error');
      }
    });
  }

  refreshTenants() {
    this.loadUnit(this.unit?.id);
  }

  addSubscription(utilityId: any) {
    this.savingSubscription = true;
    const payload: any = {
      unit_id: this.unitId,
      utility_id: utilityId,
    };

    this.store.createSubscription(payload).subscribe({
      next: (data: any) => {
        console.log(data);
        this.savingSubscription = false;
        this.loadUnit(this.unit?.id);
      },
      error: (err: any) => {
        this.savingSubscription = false;
      }
    });
  }

  addTenant() {
    const modalTemplate: any | undefined = this.modalTenantComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalTenant']);
    }
  }

  searchTenant() {
    const modalTemplate: any | undefined = this.modalSearchTenantComponent;
    if (modalTemplate) {
      this.modalSearchTenantComponent.openModal(modalTemplate['modalSearchTenant']);
    }

  }

  editUnit() {
    const modalTemplate: any | undefined = this.modalUnitComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalUnit']);
    }
  }

}
